import { Stack } from "@mui/material";
import { Skeleton } from "@mui/material";

export default function HorizontalVideoCellSkeleton() {
  return (
    <Stack flexDirection="row" width="100%" gap={1}>
      <Skeleton variant="rounded" width="35%" height={70} />
      <Stack flexGrow={1}>
        <Skeleton width="100%" />
        <Skeleton width="100%" />
        <Skeleton width="50%" />
      </Stack>
    </Stack>
  );
}
